import React from 'react'
import { QuestionComponentProps, QuestionData } from '../../type'

const Unscramble_Results = (
    {questionIndex,questionData,isCombineChild}: QuestionComponentProps) => {
        const { answers, questionText,audioUrl } = questionData;
        return (
            <div style={{ display: 'flex', gap: 5 }}>
                <div>{isCombineChild ? <i>{questionIndex + 1}.</i> : <span>{questionIndex + 1}.</span>}</div>
                <div>
                    <div>Answer: {answers}</div>
                    {audioUrl ? <div>Audio: {audioUrl}</div> : null}
                </div>
    
            </div>
        )
}

export default Unscramble_Results;